import { useEffect, useState, useRef, useCallback } from 'react'
import s from './styles.module.scss'
import { Encrypt, head, timeFormat } from 'helpers'
import { Alert, InfiniteScroll, Layouts, Loader, NoData, ImageTag, Modal, TextArea } from 'components'
import * as api from 'api'
import images from 'images'

const IMAGE_HOST = process.env.REACT_APP_IMAGE_HOST


const tabs = ['Businesses', 'Offerings', 'Profiles','Matrimonial','Jobs', 'Resumes', 'Purohit on Call', 'Mandirs']

export default function Main() {
  const [activeTab, setActiveTab] = useState(tabs[0])
  const [businesses, setBusinesses] = useState([])
  const [matrimonial, setMatrimonial ] = useState([])
  const [jobs, setJobs] = useState([])
  const [resumes, setResumes] = useState([])
  const [purohits, setPurohits] = useState([])
  const [mandirs, setMandirs] = useState([])
  const [expandedBusiness, setExpandedBusiness] = useState(0)
  const [expandedBusinessClass, setExpandedBusinessClass] = useState(1)
  const [businessRejectionMessage, setBusinessRejectionMessage] = useState('')
  const [offerings, setOfferings] = useState([])
  const [expandedOffering, setExpandedOffering] = useState(0)
  const [expandedOfferingClass, setExpandedOfferingClass] = useState(1)
  const [offeringRejectionMessage, setOfferingRejectionMessage] = useState('')
  const [users, setUsers] = useState([])
  const [expandedUser, setExpandedUser] = useState(0)
  const [expandedUserClass, setExpandedUserClass] = useState(1)
  const [userRejectionMessage, setUserRejectionMessage] = useState('')
  const [expandedMatrimonial, setExpandedMatrimonial] = useState(0)
  const [expandedMatrimonialClass, setExpandedMatrimonialClass] = useState(1)
  const [matrimonialRejectionMessage, setMatrimonialRejectionMessage] = useState('')
  const [expandedJob, setExpandedJob] = useState(null);
  const [expandedJobClass, setExpandedJobClass] = useState('');
  const [jobRejectionMessage, setJobRejectionMessage] = useState('');
  const [expandedResume, setExpandedResume] = useState(null);
  const [expandedResumeClass, setExpandedResumeClass] = useState('');
  const [resumeRejectionMessage, setResumeRejectionMessage] = useState('');
  const [totalPages, setTotalPages] = useState(0)
  const [pageNo, setPageNo] = useState(1)
  const [loading, setLoading] = useState(false)
  const processing = useRef(false)
  const perPage = 10

  const getBusinesses = useCallback(
    async (filter, currPage) => {
      if (processing.current) return
      processing.current = true
      setLoading(true)
      setPageNo(currPage + 1)

      const fetchBusinesses = await api.admin.business.fetchNewlyCreated({
        perPage,
        pageNo: currPage
      })

      if (fetchBusinesses.code === 200) {
        const items = (fetchBusinesses.payload && fetchBusinesses.payload.Businesses) || []
        setBusinesses(prev => prev.concat(items))
        const total = fetchBusinesses.payload?.total || 0
        setTotalPages(total ? Math.ceil(total / perPage) : 0)
      } else {
        Alert.error(fetchBusinesses.message)
      }

      setLoading(false)
      processing.current = false
    },
    [perPage]
  )

  const getOfferings = useCallback(
    async (filter, currPage) => {
      if (processing.current) return
      processing.current = true
      setLoading(true)
      setPageNo(currPage + 1)

      const fetchOfferings = await api.admin.listing.fetchNewlyCreated({
        perPage,
        pageNo: currPage
      })

      if (fetchOfferings.code === 200) {
        const items = (fetchOfferings.payload && fetchOfferings.payload.Listings) || []
        setOfferings(prev => prev.concat(items))
        const total = fetchOfferings.payload?.total || 0
        setTotalPages(total ? Math.ceil(total / perPage) : 0)
      } else {
        Alert.error(fetchOfferings.message)
      }

      setLoading(false)
      processing.current = false
    },
    [perPage]
  )

  const getUsers = useCallback(
    async (filter, currPage) => {
      if (processing.current) return
      processing.current = true
      setLoading(true)
      setPageNo(currPage + 1)

      const fetchUsers = await api.admin.user.fetchNewlyCreated({
        perPage,
        pageNo: currPage
      })

      if (fetchUsers.code === 200) {
        const items = (fetchUsers.payload && fetchUsers.payload.Users) || []
        setUsers(prev => prev.concat(items))
        const total = fetchUsers.payload?.total || 0
        setTotalPages(total ? Math.ceil(total / perPage) : 0)
      } else {
        Alert.error(fetchUsers.message)
      }

      setLoading(false)
      processing.current = false
    },
    [perPage]
  )
   
   const getMatrimonial = useCallback(
    async (filter, currPage) => {
      if (processing.current) return
      processing.current = true
      setLoading(true)
      setPageNo(currPage + 1)
      const fetchmatrimonial = await api.admin.matrimonial.fetchNewlyCreated({
        perPage,
        pageNo:currPage  
      })
      if (fetchmatrimonial.code === 200) {
        const items = (fetchmatrimonial.payload && fetchmatrimonial.payload.profiles) || []
        setMatrimonial(prev => prev.concat(items))
        const total = fetchmatrimonial.payload?.total || 0
        setTotalPages(total ? Math.ceil(total / perPage) : 0)
        } else {
          Alert.error(fetchmatrimonial.message)
          }
          setLoading(false)
          processing.current = false
        },
        [perPage]
    )
    const getJobs = useCallback(
      async (filter, currPage) => {
        if (processing.current) return;
        processing.current = true;
        setLoading(true);
        setPageNo(currPage + 1);
    
        const fetchJobs = await api.admin.jobs.fetchNewJobOpenings({
          perPage,
          pageNo: currPage
        });
    
        if (fetchJobs.code === 200) {
          const items = (fetchJobs.payload && fetchJobs.payload.jobs) || []
          setJobs(prev => prev.concat(items)); // ✅ FIXED
          const total = fetchJobs.payload?.total || 0
          setTotalPages(total ? Math.ceil(total / perPage) : 0);
        } else {
          Alert.error(fetchJobs.message);
        }
    
        setLoading(false);
        processing.current = false;
      },
      [perPage]
    )

    const getResumes = useCallback(
      async (filter, currPage) => {
        if (processing.current) return;
        processing.current = true;
        setLoading(true);
        setPageNo(currPage + 1);

        const fetchResumes = await api.admin.resume.fetchNewResumes({
          perPage,
          pageNo: currPage
        });

        if (fetchResumes.code === 200) {
          const items = (fetchResumes.payload && fetchResumes.payload.resumes) || []
          setResumes(prev => prev.concat(items));
          const total = fetchResumes.payload?.total || 0
          setTotalPages(total ? Math.ceil(total / perPage) : 0);
        } else {
          Alert.error(fetchResumes.message);
        }

        setLoading(false);
        processing.current = false;
      },
      [perPage]
    )

  const getPurohits = useCallback(
    async (filter, currPage) => {
      if (processing.current) return
      processing.current = true
      setLoading(true)
      setPageNo(currPage + 1)

      const response = await api.admin.purohitOnCall.fetchAll({ status: 'pending' })

      if (response?.code === 200) {
        const records = Array.isArray(response.payload) ? response.payload : []
        setPurohits(prev => (currPage === 1 ? records : prev.concat(records)))
        setTotalPages(1)
      } else {
        Alert.error(response?.message || 'Failed to load Purohit approvals.')
      }

      setLoading(false)
      processing.current = false
    },
    []
  )

  const getMandirs = useCallback(
    async (filter, currPage) => {
      if (processing.current) return
      processing.current = true
      setLoading(true)
      setPageNo(currPage + 1)

      const response = await api.admin.mandir.fetchAll({ status: 'pending' })

      if (response?.code === 200) {
        const records = Array.isArray(response.payload) ? response.payload : []
        setMandirs(prev => (currPage === 1 ? records : prev.concat(records)))
        setTotalPages(1)
      } else {
        Alert.error(response?.message || 'Failed to load Mandir approvals.')
      }

      setLoading(false)
      processing.current = false
    },
    []
  )
    

  const updateOfferingApprovalStatus = async (id, isApproved) => {
    if (!isApproved && !offeringRejectionMessage) {
      Alert.warn('Rejection message is required!!')
      return
    }

    if (processing.current) return
    processing.current = true
    setLoading(true)

    const updateOffering = await api.admin.listing.updateApprovalStatus({
      id,
      isApproved,
      rejectionMessage: isApproved ? '' : offeringRejectionMessage
    })

    if (updateOffering.code === 201) {
      let currentOffering = offerings.filter(offering => offering._id === id)[0]
      setOfferings(offerings.filter(offering => offering._id !== id))
      const notificationResponse = await api.publicApi.notifications.create({
        notification:
          (isApproved ? 'Congratulations!!! ' : '') +
          currentOffering.listingName +
          ' has been ' +
          (isApproved ? 'approved' : 'rejected please review!!'),
        fkUserId: currentOffering.fkUserId,
        redirect: Encrypt({
          path: '/userAdmin/businesses/' + Encrypt({ id: currentOffering.fkBusinessId }) + '/listings/'
        })
      })

      if (notificationResponse.code === 201) {
      } else {
        // Alert.error(notificationResponse.message)
      }
      Alert.success(updateOffering.message)
    } else {
      Alert.error(updateOffering.message)
    }

    setLoading(false)
    processing.current = false
  }

  const updateBusinessApprovalStatus = async (id, isApproved) => {
    if (!isApproved && !businessRejectionMessage) {
      Alert.warn('Rejection message is required!!')
      return
    }

    if (processing.current) return
    processing.current = true
    setLoading(true)

    const updateBusinesses = await api.admin.business.updateApprovalStatus({
      id,
      isApproved,
      rejectionMessage: isApproved ? '' : businessRejectionMessage
    })

    if (updateBusinesses.code === 201) {
      let currentBusiness = businesses.filter(business => business._id === id)[0]
      setBusinesses(businesses.filter(business => business._id !== id))
      const notificationResponse = await api.publicApi.notifications.create({
        notification:
          (isApproved ? 'Congratulations!!! ' : '') +
          currentBusiness.businessName +
          ' has been ' +
          (isApproved ? 'approved' : 'rejected please review!!'),
        fkUserId: currentBusiness.fkUserId,
        redirect: Encrypt({
          path: '/userAdmin/businesses/'
        })
      })

      if (notificationResponse.code === 201) {
      } else {
        // Alert.error(notificationResponse.message)
      }
      Alert.success(updateBusinesses.message)
    } else {
      Alert.error(updateBusinesses.message)
    }

    setLoading(false)
    processing.current = false
  }

  const updateUserApprovalStatus = async (id, isApproved) => {
    if (!isApproved && !userRejectionMessage) {
      Alert.warn('Rejection message is required!!')
      return
    }

    if (processing.current) return
    processing.current = true
    setLoading(true)

    const updateUser = await api.admin.user.updateApprovalStatus({
      id,
      isApproved,
      rejectionMessage: isApproved ? '' : userRejectionMessage
    })

    if (updateUser.code === 201) {
      let currentUser = users.filter(user => user._id === id)[0]
      setUsers(users.filter(user => user._id !== id))
      const notificationResponse = await api.publicApi.notifications.create({
        notification:
          (isApproved ? 'Congratulations!!! ' : '') +
          currentUser.firstName +
          ' ' +
          currentUser.lastName +
          ' has been ' +
          (isApproved ? 'approved' : 'rejected please review!!'),
        fkUserId: currentUser._id,
        redirect: Encrypt({
          path: '/userAdmin/editProfile'
        })
      })

      if (notificationResponse.code === 201) {
      } else {
        // Alert.error(notificationResponse.message)
      }
      Alert.success(updateUser.message)
    } else {
      Alert.error(updateUser.message)
    }
    setLoading(false)
    processing.current = false
  }

  const updateMatrimonialApprovalStatus = async (id, isApproved) => {
    if (!isApproved && !matrimonialRejectionMessage) {
      Alert.warn('Rejection message is required!!')
      return
    }
  
    if (processing.current) return
    processing.current = true
    setLoading(true)
  
    const updateMatrimonial = await api.admin.matrimonial.updateApprovalStatus({
      id,
      isApproved,
      rejectionMessage: isApproved ? '' : matrimonialRejectionMessage
    })
  
    if (updateMatrimonial.code === 201) {
      let currentMatrimonial = matrimonial.find(matrimonial => matrimonial._id === id)
      
      setMatrimonial(matrimonial.filter(matrimonial => matrimonial._id !== id))
  
      const notificationResponse = await api.publicApi.notifications.create({
        notification:
          (isApproved ? 'Congratulations!!! ' : '') +
          currentMatrimonial.fullName +
          ' profile has been ' +
          (isApproved ? 'approved' : 'rejected. Please review!!'),
          fkUserId: currentMatrimonial.fkUserId,
        redirect: Encrypt({
          path: '/userAdmin/matrimonial/'
        })
      })
  
      if (notificationResponse.code === 201) {
        // Notification sent successfully
      } else {
        // Alert.error(notificationResponse.message)
      }
  
      Alert.success(updateMatrimonial.message)
    } else {
      Alert.error(updateMatrimonial.message)
    }
  
    setLoading(false)
    processing.current = false
  }
  
  const updateApprovalStatus = async (id, isApproved) => {
    if (!isApproved && !jobRejectionMessage) {
      Alert.warn('Rejection message is required!!');
      return;
    }
  
    if (processing.current) return;
    processing.current = true;
    setLoading(true);
  
    const updateJob = await api.admin.jobs.updateJobApprovalStatus({
      id,
      isApproved,
      rejectionMessage: isApproved ? '' : jobRejectionMessage
    });
  
    if (updateJob.code === 201) {
      let currentJob = jobs.find(job => job._id === id);
      setJobs(jobs.filter(job => job._id !== id));
  
      const notificationResponse = await api.publicApi.notifications.create({
        notification:
          (isApproved ? 'Congratulations!!! ' : '') +
          currentJob.title +
          ' job posting has been ' +
          (isApproved ? 'approved' : 'rejected. Please review!!'),
        fkUserId: currentJob.fkUserId,
        redirect: Encrypt({ path: '/userAdmin/jobs/' })
      });
  
      if (notificationResponse.code !== 201) {
        // Alert.error(notificationResponse.message)
      }
      Alert.success(updateJob.message);
    } else {
      Alert.error(updateJob.message);
    }
  
    setLoading(false);
    processing.current = false;
  };

  const updateResumeApprovalStatus = async (id, isApproved) => {
    if (!isApproved && !resumeRejectionMessage) {
      Alert.warn('Rejection message is required!!');
      return;
    }

    if (processing.current) return;
    processing.current = true;
    setLoading(true);

    const updateResume = await api.admin.resume.updateResumeApprovalStatus({
      id,
      isApproved,
      rejectionMessage: isApproved ? '' : resumeRejectionMessage
    });

    if (updateResume.code === 201) {
      const currentResume = resumes.find(resume => resume._id === id);
      setResumes(resumes.filter(resume => resume._id !== id));

      if (currentResume?.fkUserId) {
        await api.publicApi.notifications.create({
          notification:
            (isApproved ? 'Congratulations!!! ' : '') +
            (currentResume.name || 'Your candidate profile') +
            ' has been ' +
            (isApproved ? 'approved' : 'rejected. Please review!!'),
          fkUserId: currentResume.fkUserId,
          redirect: Encrypt({ path: '/jobs/resume' })
        });
      }

      Alert.success(updateResume.message);
    } else {
      Alert.error(updateResume.message);
    }

    setLoading(false);
    processing.current = false;
  };
  
  const updatePurohitApprovalStatus = async id => {
    if (processing.current) return
    processing.current = true
    setLoading(true)

    const response = await api.admin.purohitOnCall.updateStatus({ id, isApproved: true })

    if (response?.code === 200) {
      setPurohits(prev => prev.filter(item => item._id !== id))
      Alert.success('Purohit profile approved successfully!')
    } else {
      Alert.error(response?.message || 'Failed to approve Purohit profile.')
    }

    setLoading(false)
    processing.current = false
  }

  const deletePurohitEntry = id => {
    Modal.Confirm('Are you sure you want to reject this Purohit submission?', async () => {
      if (processing.current) return
      processing.current = true
      setLoading(true)

      const response = await api.admin.purohitOnCall.delete(id)

      if (response?.code === 200) {
        setPurohits(prev => prev.filter(item => item._id !== id))
        Alert.success('Purohit submission removed successfully.')
      } else {
        Alert.error(response?.message || 'Failed to remove Purohit submission.')
      }

      setLoading(false)
      processing.current = false
    })
  }

  const updateMandirApprovalStatus = async id => {
    if (processing.current) return
    processing.current = true
    setLoading(true)

    const response = await api.admin.mandir.updateStatus({ id, isApproved: true })

    if (response?.code === 200) {
      setMandirs(prev => prev.filter(item => item._id !== id))
      Alert.success('Mandir profile approved successfully!')
    } else {
      Alert.error(response?.message || 'Failed to approve Mandir profile.')
    }

    setLoading(false)
    processing.current = false
  }

  const deleteMandirEntry = id => {
    Modal.Confirm('Are you sure you want to reject this Mandir submission?', async () => {
      if (processing.current) return
      processing.current = true
      setLoading(true)

      const response = await api.admin.mandir.delete(id)

      if (response?.code === 200) {
        setMandirs(prev => prev.filter(item => item._id !== id))
        Alert.success('Mandir submission removed successfully.')
      } else {
        Alert.error(response?.message || 'Failed to remove Mandir submission.')
      }

      setLoading(false)
      processing.current = false
    })
  }



  useEffect(() => {
    head({ title: 'Approval Requests | BCN' })
  }, [])

  useEffect(() => {
    if (activeTab === 'Businesses' && !businesses.length) {
      getBusinesses('', 1)
    } else if (activeTab === 'Offerings' && !offerings.length) {
      getOfferings('', 1)
    } else if (activeTab === 'Profiles' && !users.length) {
      getUsers('', 1)
    } else if (activeTab === 'Matrimonial' && !matrimonial.length) {
      getMatrimonial('', 1)
    } else if (activeTab === 'Jobs' && !jobs.length) {
      getJobs('', 1)
    } else if (activeTab === 'Resumes' && !resumes.length) {
      getResumes('', 1)
    } else if (activeTab === 'Purohit on Call' && !purohits.length) {
      getPurohits('', 1)
    } else if (activeTab === 'Mandirs' && !mandirs.length) {
      getMandirs('', 1)
    }
  }, [
    activeTab,
    businesses.length,
    offerings.length,
    users.length,
    matrimonial.length,
    jobs.length,
    resumes.length,
    purohits.length,
    mandirs.length,
    getBusinesses,
    getOfferings,
    getUsers,
    getMatrimonial,
    getJobs,
    getResumes,
    getPurohits,
    getMandirs
  ])

  return (
    <div className={s.main}>
      <div className={s.approvalrequests}>
        <Layouts.Classic title='Approval Requests' />
        <div className={s.content + ' innerScrollX'}>
          <div className={s.tabs}>
            {!!tabs.length &&
              tabs.map((tab, i) => (
                <div
                  className={activeTab === tab ? s.tab + ' ' + s.active : s.tab}
                  onClick={() => {
                    setPageNo(1)
                    setTotalPages(0)
                    setBusinesses([])
                    setUsers([])
                    setOfferings([])
                    setMatrimonial([])
                    setJobs([])
                    setResumes([])
                    setPurohits([])
                    setMandirs([])
                    setActiveTab(tab)
                  }}
                  key={i}
                >
                  {tab}
                </div>
              ))}
          </div>
          {!loading &&
            ((activeTab === 'Businesses' && !businesses.length) ||
              (activeTab === 'Offerings' && !offerings.length) ||
              (activeTab === 'Profiles' && !users.length) ||
              (activeTab === 'Matrimonial' && !matrimonial.length) ||
              (activeTab === 'Jobs' && !jobs.length) ||
              (activeTab === 'Resumes' && !resumes.length) ||
              (activeTab === 'Purohit on Call' && !purohits.length) ||
              (activeTab === 'Mandirs' && !mandirs.length)) && <NoData />}
          <InfiniteScroll
            next={
              activeTab === 'Businesses'
                ? getBusinesses
                : activeTab === 'Offerings'
                ? getOfferings
                : activeTab === 'Matrimonial'
                ? getMatrimonial
                : activeTab === 'Jobs'
                ? getJobs
                : activeTab === 'Resumes'
                ? getResumes
                : activeTab === 'Purohit on Call'
                ? getPurohits
                : activeTab === 'Mandirs'
                ? getMandirs
                : getUsers
            }
            filter=''
            currentPage={pageNo}
            hasMore={pageNo <= totalPages}
            inLayout
          >
            {!!businesses.length && activeTab === 'Businesses' && (
              <div className={s.businesses}>
                {businesses.map((business, i) => (
                  <BusinessApprovalCard
                    business={business}
                    expandedBusiness={expandedBusiness}
                    setExpandedBusiness={setExpandedBusiness}
                    expandedBusinessClass={expandedBusinessClass}
                    setExpandedBusinessClass={setExpandedBusinessClass}
                    updateBusinessApprovalStatus={updateBusinessApprovalStatus}
                    businessRejectionMessage={businessRejectionMessage}
                    setBusinessRejectionMessage={setBusinessRejectionMessage}
                    index={i}
                    key={i}
                  />
                ))}
              </div>
            )}

            {!!offerings.length && activeTab === 'Offerings' && (
              <div className={s.offerings}>
                {offerings.map((offering, i) => (
                  <OfferingsApprovalCard
                    offering={offering}
                    expandedOffering={expandedOffering}
                    setExpandedOffering={setExpandedOffering}
                    expandedOfferingClass={expandedOfferingClass}
                    setExpandedOfferingClass={setExpandedOfferingClass}
                    updateOfferingApprovalStatus={updateOfferingApprovalStatus}
                    offeringRejectionMessage={offeringRejectionMessage}
                    setOfferingRejectionMessage={setOfferingRejectionMessage}
                    index={i}
                    key={i}
                  />
                ))}
              </div>
            )}
            {!!matrimonial.length && activeTab === 'Matrimonial' && (
              <div className={s.matrimonial}>
                {matrimonial.map((matrimonial, i) => (
                  <MatrimonialApprovalCard
                  matrimonial={matrimonial}
                  expandedMatrimonial={expandedMatrimonial}
                  setExpandedMatrimonial={setExpandedMatrimonial}
                  expandedMatrimonialClass={expandedMatrimonialClass}
                  setExpandedMatrimonialClass={setExpandedMatrimonialClass}
                  updateMatrimonialApprovalStatus={updateMatrimonialApprovalStatus}
                  matrimonialRejectionMessage={matrimonialRejectionMessage}
                  setmatrimonialRejectionMessage={setMatrimonialRejectionMessage}
                  index={i}
                  key={i}
                  />
                ))}
                </div>
            )}

{!!jobs.length && activeTab === 'Jobs' && (
  <div className={s.jobs}>
    {jobs.map((job, i) => (
      <JobApprovalCard
        jobs={job}
        expandedJob={expandedJob}
        setExpandedJob={setExpandedJob}
        expandedJobClass={expandedJobClass}
        setExpandedJobClass={setExpandedJobClass}
        updateApprovalStatus={updateApprovalStatus}
        jobRejectionMessage={jobRejectionMessage}
        setJobRejectionMessage={setJobRejectionMessage}
        index={i}
        key={i}
      />
    ))}
  </div>
)}

{!!resumes.length && activeTab === 'Resumes' && (
  <div className={s.jobs}>
    {resumes.map((resume, i) => (
      <ResumeApprovalCard
        resume={resume}
        expandedResume={expandedResume}
        setExpandedResume={setExpandedResume}
        expandedResumeClass={expandedResumeClass}
        setExpandedResumeClass={setExpandedResumeClass}
        updateApprovalStatus={updateResumeApprovalStatus}
        resumeRejectionMessage={resumeRejectionMessage}
        setResumeRejectionMessage={setResumeRejectionMessage}
        index={i}
        key={resume._id || i}
      />
    ))}
  </div>
)}

            {!!purohits.length && activeTab === 'Purohit on Call' && (
              <div className={s.offerings}>
                {purohits.map((purohit, i) => (
                  <PurohitApprovalCard
                    purohit={purohit}
                    onApprove={() => updatePurohitApprovalStatus(purohit._id)}
                    onReject={() => deletePurohitEntry(purohit._id)}
                    key={purohit._id || i}
                  />
                ))}
              </div>
            )}

            {!!mandirs.length && activeTab === 'Mandirs' && (
              <div className={s.offerings}>
                {mandirs.map((mandir, i) => (
                  <MandirApprovalCard
                    mandir={mandir}
                    onApprove={() => updateMandirApprovalStatus(mandir._id)}
                    onReject={() => deleteMandirEntry(mandir._id)}
                    key={mandir._id || i}
                  />
                ))}
              </div>
            )}

            {!!users.length && activeTab === 'Profiles' && (
              <div className={s.users}>
                {users.map((user, i) => (
                  <UsersApprovalCard
                    user={user}
                    expandedUser={expandedUser}
                    setExpandedUser={setExpandedUser}
                    expandedUserClass={expandedUserClass}
                    setExpandedUserClass={setExpandedUserClass}
                    updateUserApprovalStatus={updateUserApprovalStatus}
                    userRejectionMessage={userRejectionMessage}
                    setUserRejectionMessage={setUserRejectionMessage}
                    index={i}
                    key={i}
                  />
                ))}
              </div>
            )}
          </InfiniteScroll>
          {!!loading && <Loader color='var(--c-primary)' colorText='var(--c-primary)' />}
        </div>
      </div>
    </div>
  )
}

const BusinessApprovalCard = props => (
  <div
    className={s.businessApprovalCard}
    style={{
      height:
        props.index === props.expandedBusiness ? (props.expandedBusinessClass === 1 ? '100%' : '3.75rem') : '3.75rem'
    }}
  >
    <div className={s.businessName}>
      <div>
        <span className='material-icons-outlined'>business</span>
        {props.business.businessName}
      </div>
      <div className={s.updatedAt}>
        <span className='material-icons-outlined'>update</span>
        Last Updated On:
        <span>{timeFormat(props.business.updatedAt, true)}</span>
      </div>
    </div>
    {!!props.business.images.length && (
      <div className={s.images}>
        {props.business.images.map((image, i) => (
          <div className={s.image} key={i}>
            <ImageTag src={IMAGE_HOST + image} alt='' />
          </div>
        ))}
      </div>
    )}
    <div className={s.row}>
      <div className={s.state}>
        <span className='material-icons-outlined'>location_on</span>
        State: <span>{props.business.state}</span>
      </div>
      <div className={s.city}>
        <span className='material-icons-outlined'>location_on</span>
        City: <span>{props.business.city}</span>
      </div>
    </div>
    <div className={s.row}>
      <div className={s.category}>
        <span className='material-icons-outlined'>category</span>
        Category: <span>{props.business.category}</span>
      </div>
      {!!props.business.subCategory && (
        <div className={s.subCategory}>
          <span className='material-icons-outlined'>category</span>
          Sub-Category: <span>{props.business.subCategory}</span>
        </div>
      )}
    </div>
    <a href={'tel:+91' + props.business.phoneNo} className={s.phoneNo}>
      <span className='material-icons-outlined'>call</span>
      Contact No. : <span>+91-{props.business.phoneNo}</span>
    </a>
    {!!props.business.address && (
      <div className={s.address}>
        <span className='material-icons-outlined'>home</span>
        Address: <span>{props.business.address}</span>
      </div>
    )}
    {!!props.business.website && (
      <div className={s.website}>
        <span className='material-icons-outlined'>language</span>
        Website: <span>{props.business.website}</span>
      </div>
    )}
    {(!!props.business.facebookLink || !!props.instagramLink) && (
      <div className={s.row}>
        {props.business.facebookLink && (
          <a href={props.business.facebookLink} target='_blank' rel='noreferrer' className={s.facebook}>
            <div className={s.image}>
              <img src={images.facebookAlt} alt='' />
            </div>
            Facebook
          </a>
        )}
        {props.business.instagramLink && (
          <a href={props.business.instagramLink} target='_blank' rel='noreferrer' className={s.instagram}>
            <div className={s.image}>
              <img src={images.instagramAlt} alt='' />
            </div>
            Instagram
          </a>
        )}
      </div>
    )}
    {!!props.business.tags && props.business.tags.length !== 0 && (
      <div className={s.tags}>
        <div className={s.tagHeading}>Business Keywords</div>
        <div className={s.addedTags}>
          {props.business.tags.map((tag, i) => (
            <div className={s.tag} key={i}>
              {tag}
            </div>
          ))}
        </div>
      </div>
    )}
    <div className={s.description}>
      <span className='material-icons-outlined'>description</span>
      {props.business.description}
    </div>
    <div className={s.rejectionReason}>
      <TextArea.Classic
        label='Rejection Message (Max. 200 words)'
        iconLeft='description'
        placeholder='Enter rejection message...'
        value={props.businessRejectionMessage}
        onChange={e => {
          if (e.target.value.trim().split(/\s+/).length <= 200) props.setBusinessRejectionMessage(e.target.value)
        }}
      />
    </div>
    <div className={s.actionButtons}>
      <div
        className={s.approve}
        onClick={() =>
          Modal.Confirm('Are u sure u want to approve ' + props.business.businessName + '?', () =>
            props.updateBusinessApprovalStatus(props.business._id, true)
          )
        }
      >
        <span className='material-icons-outlined'>done</span> Approve
      </div>
      <div
        className={s.reject}
        onClick={() =>
          Modal.Confirm('Are u sure u want to reject ' + props.business.businessName + '?', () =>
            props.updateBusinessApprovalStatus(props.business._id, false)
          )
        }
      >
        <span className='material-icons-outlined'>close</span>Reject
      </div>
    </div>
    <div
      className={
        props.index === props.expandedBusiness
          ? props.expandedBusinessClass === 1
            ? s.expand + ' ' + s.expandActive
            : s.expand
          : s.expand
      }
      onClick={e => {
        props.setExpandedBusiness(props.index)
        props.setExpandedBusinessClass(e.currentTarget.classList.length)
      }}
    >
      <span className='material-icons-outlined'>
        {props.index === props.expandedBusiness
          ? props.expandedBusinessClass === 1
            ? 'expand_less'
            : 'expand_more'
          : ' expand_more'}
      </span>
    </div>
  </div>
)

const OfferingsApprovalCard = props => (
  <div
    className={s.offeringsApprovalCard}
    style={{
      height:
        props.index === props.expandedOffering ? (props.expandedOfferingClass === 1 ? '100%' : '3.75rem') : '3.75rem'
    }}
  >
    <div className={s.offeringName}>
      <div>
        <span className='material-icons-outlined'>badge</span>
        {props.offering.listingName}
      </div>
      <div className={s.updatedAt}>
        <span className='material-icons-outlined'>update</span>
        Last Updated On:
        <span>{timeFormat(props.offering.updatedAt, true)}</span>
      </div>
    </div>
    {!!props.offering.images.length && (
      <div className={s.images}>
        {props.offering.images.map((image, i) => (
          <div className={s.image} key={i}>
            <ImageTag src={IMAGE_HOST + image} alt='' />
          </div>
        ))}
      </div>
    )}
    <div className={s.row}>
      <div className={s.category}>
        <span className='material-icons-outlined'>category</span>
        Category: <span>{props.offering.category}</span>
      </div>
      {!!props.offering.subCategory && (
        <div className={s.subCategory}>
          <span className='material-icons-outlined'>category</span>
          Sub-Category: <span>{props.offering.subCategory}</span>
        </div>
      )}
    </div>
    <div className={s.contactPerson}>
      <span className='material-icons-outlined'>person</span>
      Contact Person: <span>{props.offering.contactPerson}</span>
    </div>
    <a href={'tel:+91' + props.offering.phoneNo} className={s.phoneNo}>
      <span className='material-icons-outlined'>call</span>
      Contact No. : <span>+91-{props.offering.phoneNo}</span>
    </a>
    <div className={s.description}>
      <span className='material-icons-outlined'>description</span>
      {props.offering.description}
    </div>
    <div className={s.rejectionReason}>
      <TextArea.Classic
        label='Rejection Message (Max. 200 words)'
        iconLeft='description'
        placeholder='Enter rejection message...'
        value={props.offeringRejectionMessage}
        onChange={e => {
          if (e.target.value.trim().split(/\s+/).length <= 200) props.setOfferingRejectionMessage(e.target.value)
        }}
      />
    </div>
    <div className={s.actionButtons}>
      <div
        className={s.approve}
        onClick={() =>
          Modal.Confirm('Are u sure u want to approve ' + props.offering.listingName + '?', () =>
            props.updateOfferingApprovalStatus(props.offering._id, true)
          )
        }
      >
        <span className='material-icons-outlined'>done</span> Approve
      </div>
      <div
        className={s.reject}
        onClick={() =>
          Modal.Confirm('Are u sure u want to reject ' + props.offering.listingName + '?', () =>
            props.updateOfferingApprovalStatus(props.offering._id, false)
          )
        }
      >
        <span className='material-icons-outlined'>close</span>Reject
      </div>
    </div>
    <div
      className={
        props.index === props.expandedOffering
          ? props.expandedOfferingClass === 1
            ? s.expand + ' ' + s.expandActive
            : s.expand
          : s.expand
      }
      onClick={e => {
        props.setExpandedOffering(props.index)
        props.setExpandedOfferingClass(e.currentTarget.classList.length)
      }}
    >
      <span className='material-icons-outlined'>
        {props.index === props.expandedOffering
          ? props.expandedOfferingClass === 1
            ? 'expand_less'
            : 'expand_more'
          : ' expand_more'}
      </span>
    </div>
  </div>
)

const PurohitApprovalCard = ({ purohit, onApprove, onReject }) => (
  <div className={s.offeringsApprovalCard}>
    <div className={s.offeringName}>
      <div>
        <span className='material-icons-outlined'>record_voice_over</span>
        {purohit.fullName}
      </div>
      <div className={s.updatedAt}>
        <span className='material-icons-outlined'>update</span>
        Submitted:
        <span>{timeFormat(purohit.createdAt, true)}</span>
      </div>
    </div>
    <div className={s.row}>
      <div>
        <span className='material-icons-outlined'>person</span>
        Father Name: <span>{purohit.fatherName || '—'}</span>
      </div>
      <div>
        <span className='material-icons-outlined'>call</span>
        Mobile: <span>{purohit.mobile}</span>
      </div>
    </div>
    <div className={s.row}>
      <div>
        <span className='material-icons-outlined'>location_on</span>
        City: <span>{purohit.city || '—'}</span>
      </div>
      <div>
        <span className='material-icons-outlined'>history</span>
        Experience: <span>{purohit.experienceYears ? `${purohit.experienceYears} yrs` : '—'}</span>
      </div>
    </div>
    {!!(purohit.serviceSpecializations && purohit.serviceSpecializations.length) && (
      <div className={s.tags}>
        <div className={s.addedTags}>
          {purohit.serviceSpecializations.map((tag, idx) => (
            <div className={s.tag} key={idx}>
              {tag}
            </div>
          ))}
        </div>
      </div>
    )}
    <div className={s.actionButtons}>
      <div
        className={s.approve}
        onClick={() => Modal.Confirm('Approve this Purohit profile?', onApprove)}
      >
        <span className='material-icons-outlined'>done</span> Approve
      </div>
      <div
        className={s.reject}
        onClick={() => Modal.Confirm('Reject this Purohit profile?', onReject)}
      >
        <span className='material-icons-outlined'>close</span>Reject
      </div>
    </div>
  </div>
)

const MandirApprovalCard = ({ mandir, onApprove, onReject }) => (
  <div className={s.offeringsApprovalCard}>
    <div className={s.offeringName}>
      <div>
        <span className='material-icons-outlined'>temple_hindu</span>
        {mandir.mandirName}
      </div>
      <div className={s.updatedAt}>
        <span className='material-icons-outlined'>update</span>
        Submitted:
        <span>{timeFormat(mandir.createdAt, true)}</span>
      </div>
    </div>
    <div className={s.row}>
      <div>
        <span className='material-icons-outlined'>location_on</span>
        {[mandir.city, mandir.state].filter(Boolean).join(', ') || '—'}
      </div>
      <div>
        <span className='material-icons-outlined'>call</span>
        Contact: <span>{mandir.contactPhone || '—'}</span>
      </div>
    </div>
    {!!mandir.contactName && (
      <div className={s.row}>
        <div>
          <span className='material-icons-outlined'>person</span>
          Contact Person: <span>{mandir.contactName}</span>
        </div>
      </div>
    )}
    {!!mandir.purohit?.fullName && (
      <div className={s.row}>
        <div>
          <span className='material-icons-outlined'>self_improvement</span>
          Main Purohit: <span>{mandir.purohit.fullName}</span>
        </div>
        <div>
          <span className='material-icons-outlined'>call</span>
          Mobile: <span>{mandir.purohit.mobile || '—'}</span>
        </div>
      </div>
    )}
    <div className={s.actionButtons}>
      <div
        className={s.approve}
        onClick={() => Modal.Confirm('Approve this Mandir profile?', onApprove)}
      >
        <span className='material-icons-outlined'>done</span> Approve
      </div>
      <div
        className={s.reject}
        onClick={() => Modal.Confirm('Reject this Mandir profile?', onReject)}
      >
        <span className='material-icons-outlined'>close</span>Reject
      </div>
    </div>
  </div>
)

const UsersApprovalCard = props => (
  <div
    className={s.userApprovalCard}
    style={{
      height: props.index === props.expandedUser ? (props.expandedUserClass === 1 ? '100%' : '3.75rem') : '3.75rem'
    }}
  >
    <div className={s.userName}>
      <div>
        <span className='material-icons-outlined'>person</span>

        {props.user.firstName + ' ' + props.user.lastName}
      </div>
      <div className={s.updatedAt}>
        <span className='material-icons-outlined'>update</span>
        Last Updated On:
        <span>{timeFormat(props.user.updatedAt, true)}</span>
      </div>
    </div>
    {!!props.user.logo && (
      <div className={s.images}>
        <div className={s.image}>
          <ImageTag src={IMAGE_HOST + props.user.logo} alt='' />
        </div>
      </div>
    )}
    <div className={s.gender}>
      <span className='material-icons-outlined'>male</span>
      Gender: <span>{props.user.gender}</span>
    </div>
    <div className={s.row}>
      {!!props.user.email && (
        <a href={'mailto:' + props.user.email} className={s.email}>
          <span className='material-icons-outlined'>email</span>
          Email: <span>{props.user.email}</span>
        </a>
      )}
      <a href={'tel:+91' + props.user.phoneNo} className={s.phoneNo}>
        <span className='material-icons-outlined'>call</span>
        Contact No. : <span>+91-{props.user.phoneNo}</span>
      </a>
    </div>

    <div className={s.row}>
      <div className={s.state}>
        <span className='material-icons-outlined'>location_on</span>
        State: <span>{props.user.state}</span>
      </div>
      <div className={s.city}>
        <span className='material-icons-outlined'>location_on</span>
        City: <span>{props.user.city}</span>
      </div>
    </div>
    {!!props.user.address && (
      <div className={s.address}>
        <span className='material-icons-outlined'>home</span>
        Address: <span>{props.user.address}</span>
      </div>
    )}
    <div className={s.rejectionReason}>
      <TextArea.Classic
        label='Rejection Message (Max. 200 words)'
        iconLeft='description'
        placeholder='Enter rejection message...'
        value={props.userRejectionMessage}
        onChange={e => {
          if (e.target.value.trim().split(/\s+/).length <= 200) props.setUserRejectionMessage(e.target.value)
        }}
      />
    </div>
    <div className={s.actionButtons}>
      <div
        className={s.approve}
        onClick={() =>
          Modal.Confirm('Are u sure u want to approve ' + props.user.firstName + ' ' + props.user.lastName + '?', () =>
            props.updateUserApprovalStatus(props.user._id, true)
          )
        }
      >
        <span className='material-icons-outlined'>done</span> Approve
      </div>
      <div
        className={s.reject}
        onClick={() =>
          Modal.Confirm('Are u sure u want to reject ' + props.user.firstName + ' ' + props.user.lastName + '?', () =>
            props.updateUserApprovalStatus(props.user._id, false)
          )
        }
      >
        <span className='material-icons-outlined'>close</span>Reject
      </div>
    </div>
    <div
      className={
        props.index === props.expandedUser
          ? props.expandedUserClass === 1
            ? s.expand + ' ' + s.expandActive
            : s.expand
          : s.expand
      }
      onClick={e => {
        props.setExpandedUser(props.index)
        props.setExpandedUserClass(e.currentTarget.classList.length)
      }}
    >
      <span className='material-icons-outlined'>
        {props.index === props.expandedUser
          ? props.expandedUserClass === 1
            ? 'expand_less'
            : 'expand_more'
          : ' expand_more'}
      </span>
    </div>
  </div>
)
const MatrimonialApprovalCard = props => (
  <div
    className={s.matrimonialApprovalMatrimonial}
    style={{
      height:
        props.index === props.expandedMatrimonial
          ? props.expandedMatrimonialClass === 1
            ? '100%'
            : '3.75rem'
          : '3.75rem'
    }}
  >
    <div className={s.header}>
      <div>
        <span className='material-icons-outlined'>person</span>
        {props.matrimonial.fullName}
      </div>
      <div className={s.updatedAt}>
        <span className='material-icons-outlined'>update</span>
        Last Updated On:
        <span>{timeFormat(props.matrimonial.updatedAt, true)}</span>
      </div>
    </div>

    {!!props.matrimonial.photo && (
      <div className={s.photo}>
        <ImageTag src={IMAGE_HOST + props.matrimonial.photo} alt='Profile' />
      </div>
    )}

    <div className={s.row}>
      <div className={s.gender}>
        <span className='material-icons-outlined'>wc</span>
        Gender: <span>{props.matrimonial.gender}</span>
      </div>
      <div className={s.dob}>
        <span className='material-icons-outlined'>cake</span>
        DOB: <span>{props.matrimonial.dateOfBirth}</span>
      </div>
    </div>

    <div className={s.row}>
      <div className={s.state}>
        <span className='material-icons-outlined'>location_on</span>
        State: <span>{props.matrimonial.state}</span>
      </div>
      <div className={s.city}>
        <span className='material-icons-outlined'>location_on</span>
        City: <span>{props.matrimonial.city}</span>
      </div>
    </div>

    {!!props.matrimonial.contactNumber && (
      <a href={'tel:+91' + props.matrimonial.contactNumber} className={s.phoneNo}>
        <span className='material-icons-outlined'>call</span>
        Contact No. : <span>+91-{props.matrimonial.contactNumber}</span>
      </a>
    )}

    {!!props.matrimonial.email && (
      <div className={s.email}>
        <span className='material-icons-outlined'>mail</span>
        Email: <span>{props.matrimonial.email}</span>
      </div>
    )}
     <div className={s.rejectionReason}>
      <TextArea.Classic
        label='Rejection Message (Max. 200 words)'
        iconLeft='description'
        placeholder='Enter rejection message...'
        value={props.matrimonialRejectionMessage}
        onChange={e => {
          if (e.target.value.trim().split(/\s+/).length <= 200) props.setMatrimonialRejectionMessage(e.target.value)
        }}
      />
    </div>
    <div className={s.actionButtons}>
      <div
        className={s.approve}
        onClick={() =>
          Modal.Confirm('Are you sure you want to approve ' + props.matrimonial.fullName + '?', () =>
            props.updateMatrimonialApprovalStatus(props.matrimonial._id, true)
          )
        }
      >
        <span className='material-icons-outlined'>done</span> Approve
      </div>
      <div
        className={s.reject}
        onClick={() =>
          Modal.Confirm('Are you sure you want to reject ' + props.matrimonial.fullName + '?', () =>
            props.updateMatrimonialApprovalStatus(props.matrimonial._id, false)
          )
        }
      >
        <span className='material-icons-outlined'>close</span> Reject
      </div>
    </div>

    <div
      className={
        props.index === props.expandedMatrimonial
          ? props.expandedMatrimonialClass === 1
            ? s.expand + ' ' + s.expandActive
            : s.expand
          : s.expand
      }
      onClick={e => {
        props.setExpandedMatrimonial(props.index)
        props.setExpandedMatrimonialClass(e.currentTarget.classList.length)
      }}
    >
      <span className='material-icons-outlined'>
        {props.index === props.expandedMatrimonial
          ? props.expandedMatrimonialClass === 1
            ? 'expand_less'
            : 'expand_more'
          : 'expand_more'}
      </span>
    </div>
  </div>
)
const JobApprovalCard = props => (
  <div
    className={s.jobApprovalCard}
    style={{
      height:
        props.index === props.expandedJob
          ? props.expandedJobClass === 1
            ? '100%'
            : '3.75rem'
          : '3.75rem'
    }}
  >
    <div className={s.header}>
      <div>
        <span className='material-icons-outlined'>work</span>
        {props.jobs.job_title}
      </div>
      <div className={s.updatedAt}>
        <span className='material-icons-outlined'>update</span>
        Last Updated On:
        <span>{timeFormat(props.jobs.updatedAt, true)}</span>
      </div>
    </div>

    <div className={s.row}>
      <div className={s.company}>
        <span className='material-icons-outlined'>business</span>
        Company: <span>{props.jobs.company_name}</span>
      </div>
      <div className={s.location}>
        <span className='material-icons-outlined'>location_on</span>
        Location: <span>{props.jobs.city}</span>
      </div>
    </div>

    <div className={s.row}>
    {/* <div className={s.salary}>
    <span className='material-icons-outlined'>attach_money</span>
    Salary: <span>{props.jobs.salary}</span>
  </div> */}
  {/* <div className={s.experience}>
    <span className='material-icons-outlined'>insights</span>
    Experience: <span>{props.jobs.experience}</span>
  </div> */}
</div>

{/* {!!props.jobs.contactEmail && (
  <div className={s.email}>
    <span className='material-icons-outlined'>mail</span>
    Email: <span>{props.jobs.contactEmail}</span>
  </div>
)} */}

{!!props.jobs.contact_number && (
  <a href={`tel:+91${props.jobs.contact_number}`} className={s.phoneNo}>
    <span className='material-icons-outlined'>call</span>
    Contact No.: <span>+91-{props.jobs.contact_number}</span>
  </a>
)}

    <div className={s.rejectionReason}>
      <TextArea.Classic
        label='Rejection Message (Max. 200 words)'
        iconLeft='description'
        placeholder='Enter rejection message...'
        value={props.jobRejectionMessage}
        onChange={e => {
          if (e.target.value.trim().split(/\s+/).length <= 200) {
            props.setJobRejectionMessage(e.target.value);
          }
        }}
      />
    </div>

    <div className={s.actionButtons}>
      <div
        className={s.approve}
        onClick={() =>
          Modal.Confirm(`Are you sure you want to approve ${props.jobs.jobTitle}?`, () =>
            props.updateApprovalStatus(props.jobs._id, true)
          )
        }
      >
        <span className='material-icons-outlined'>done</span> Approve
      </div>
      <div
        className={s.reject}
        onClick={() =>
          Modal.Confirm(`Are you sure you want to reject ${props.jobs.jobTitle}?`, () =>
            props.updateApprovalStatus(props.jobs._id, false)
          )
        }
      >
        <span className='material-icons-outlined'>close</span> Reject
      </div>
    </div>

    <div
      className={
        props.index === props.expandedJob && props.expandedJobClass === 1
          ? `${s.expand} ${s.expandActive}`
          : s.expand
      }
      onClick={e => {
        props.setExpandedJob(props.index);
        props.setExpandedJobClass(e.currentTarget.classList.length);
      }}
    >
      <span className='material-icons-outlined'>
        {props.index === props.expandedJob && props.expandedJobClass === 1
          ? 'expand_less'
          : 'expand_more'}
      </span>
    </div>
  </div>
);

const ResumeApprovalCard = props => (
  <div
    className={s.jobApprovalCard}
    style={{
      height:
        props.index === props.expandedResume
          ? props.expandedResumeClass === 1
            ? '100%'
            : '3.75rem'
          : '3.75rem'
    }}
  >
    <div className={s.header}>
      <div>
        <span className='material-icons-outlined'>badge</span>
        {props.resume.name}
      </div>
      <div className={s.updatedAt}>
        <span className='material-icons-outlined'>update</span>
        Last Updated On:
        <span>{timeFormat(props.resume.updatedAt, true)}</span>
      </div>
    </div>

    <div className={s.row}>
      <div className={s.company}>
        <span className='material-icons-outlined'>work</span>
        Role: <span>{props.resume.jobRole}</span>
      </div>
      <div className={s.location}>
        <span className='material-icons-outlined'>location_on</span>
        Location: <span>{props.resume.city}, {props.resume.state}</span>
      </div>
    </div>

    <div className={s.row}>
      <div className={s.company}>
        <span className='material-icons-outlined'>category</span>
        Field: <span>{props.resume.functionalArea}</span>
      </div>
      <div className={s.location}>
        <span className='material-icons-outlined'>insights</span>
        Experience: <span>{props.resume.experience}</span>
      </div>
    </div>

    {!!props.resume.email && (
      <div className={s.email}>
        <span className='material-icons-outlined'>mail</span>
        Email: <span>{props.resume.email}</span>
      </div>
    )}

    {!!props.resume.phone && (
      <a href={`tel:+91${props.resume.phone}`} className={s.phoneNo}>
        <span className='material-icons-outlined'>call</span>
        Contact No.: <span>+91-{props.resume.phone}</span>
      </a>
    )}

    <div className={s.rejectionReason}>
      <TextArea.Classic
        label='Rejection Message (Max. 200 words)'
        iconLeft='description'
        placeholder='Enter rejection message...'
        value={props.resumeRejectionMessage}
        onChange={e => {
          if (e.target.value.trim().split(/\s+/).length <= 200) {
            props.setResumeRejectionMessage(e.target.value);
          }
        }}
      />
    </div>

    <div className={s.actionButtons}>
      <div
        className={s.approve}
        onClick={() =>
          Modal.Confirm(`Are you sure you want to approve ${props.resume.name}?`, () =>
            props.updateApprovalStatus(props.resume._id, true)
          )
        }
      >
        <span className='material-icons-outlined'>done</span> Approve
      </div>
      <div
        className={s.reject}
        onClick={() =>
          Modal.Confirm(`Are you sure you want to reject ${props.resume.name}?`, () =>
            props.updateApprovalStatus(props.resume._id, false)
          )
        }
      >
        <span className='material-icons-outlined'>close</span> Reject
      </div>
    </div>

    <div
      className={
        props.index === props.expandedResume && props.expandedResumeClass === 1
          ? `${s.expand} ${s.expandActive}`
          : s.expand
      }
      onClick={e => {
        props.setExpandedResume(props.index);
        props.setExpandedResumeClass(e.currentTarget.classList.length);
      }}
    >
      <span className='material-icons-outlined'>
        {props.index === props.expandedResume && props.expandedResumeClass === 1
          ? 'expand_less'
          : 'expand_more'}
      </span>
    </div>
  </div>
);



